/*--BrowserRouter--*/
import { useState } from 'react';
import { Link } from 'react-router';
import { BrowserRouter, Routes, Route } from "react-router-dom";

/*--strony--*/

import Blog from "./blog.js";
import Sticks from "./sticks.js"
import Album from "./gallery.js";
import Meat from "./meat.js";
import Tour from "./tour.js";
import Wine from "./wine.js";
import Story from "./story.js";
import ScrollToTop from "../ScrollToTop.jsx";


/*--css--*/

import '../assets/css/App.css';
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--cows on main--*/

import img1 from '../assets/img/lower/4.webp';
import img2 from '../assets/img/lower/18.webp';
import img3 from '../assets/img/lower/15.webp';
import video from '../assets/video/cattle.mp4';
import wine from '../assets/img/lower/wine2.webp';
import meat from '../assets/img/higher/mieso.webp';
import sticks from '../assets/paluszki/lower/stos2.webp';
import highlader from '../assets/img/lower/higlader.webp';
import pic1 from '../assets/img/lower/1.webp';
import pic2 from '../assets/img/lower/23.webp';
import pic3 from '../assets/img/lower/19.webp';
import pic4 from '../assets/img/lower/2.webp';
import pic5 from '../assets/img/lower/17.webp';
import short1 from '../assets/paluszki/lower/stos2.webp';
import short2 from '../assets/img/lower/miensko.webp';
import short3 from '../assets/img/lower/lezakowanie.webp';
import short4 from '../assets/img/lower/22.webp';

/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';

/*--logo--*/
import logo from '../assets/img/logo.webp';

/*--higher versions--*/

  /*--cows on main--*/
  import img1h from '../assets/img/higher/4.webp';
  import img2h from '../assets/img/higher/18.webp';
  import img3h from '../assets/img/higher/15.webp';
  import wineh from '../assets/img/higher/wine2.webp';
  import sticksh from '../assets/paluszki/higher/stos2.webp';
  import highladerh from '../assets/img/higher/higlader.webp';
  import pic1h from '../assets/img/higher/1.webp';
  import pic2h from '../assets/img/higher/23.webp';
  import pic3h from '../assets/img/higher/19.webp';
  import pic4h from '../assets/img/higher/2.webp';
  import pic5h from '../assets/img/higher/17.webp';
  import short1h from '../assets/paluszki/higher/stos2.webp';
  import short2h from '../assets/img/higher/miensko.webp';
  import short3h from '../assets/img/higher/lezakowanie.webp';
  import short4h from '../assets/img/higher/22.webp';
  /*--cows footer--*/
  import mu1h from '../assets/cowsss/higher/3.webp';
  import mu2h from '../assets/cowsss/higher/5.webp';
  import mu3h from '../assets/cowsss/higher/6.webp';
  import mu4h from '../assets/cowsss/higher/7.webp';
  import mu5h from '../assets/cowsss/higher/4.webp';
  import mu6h from '../assets/cowsss/higher/1.webp';

/*========------------========*/
/*========------------========*/
/*------Header and Welcome------*/
/*========------------========*/
/*========------------========*/


function Welcome() {
  return (
    <>
      {/*==Welcome==*/}
      <article className='Welcome'>
        <Header />
        <Text />
      </article>
    </>
  );
}

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" >
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <button>O nas</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <button>Produkty</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button>Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" >
                  <button>Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}

function Text() {
  return (
    <>
      {/*==Text and button in Welcome==*/}
      <Container className='PageDesc' fluid>
        <Row>
          <Col lg={12}>
            <h1>Beskidzkie Stado</h1>
          </Col>
          <Col lg={12}>
            <a href='#About'>
              <button>Zobacz więcej &#8594;</button>
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
}


/*========------------========*/
/*========------------========*/
/*------SectionOne------*/
/*========------------========*/
/*========------------========*/

function SectionOne({Changing}) {
  return (
    <>
      {/*====Section1====*/}
      <section className='sectionOne' id='About'>
        <Row>
          {/*==Text in SectionOne==*/}
          <Col lg={4} md={12} xs={12} className='secText'>
            <div>
              <p>
                Nasza farma specjalizuje się w hodowli krów rasy Highland, które są symbolem górskiego krajobrazu. Oferujemy także ekologiczne paluszki pełnoziarniste oraz wina, które powstają z pasji i staranności. Zapraszamy do odkrywania naturalnych smaków naszej ziemi.
              </p>
            </div>
          </Col>
          {/*==Images in SectionOne==*/}
          <Col lg={8} md={12} xs={12} className='secImages'>
            <div className='setImg'>
                {/*--first img--*/}
                <div className='pic1'>
                  <img onLoad={Changing} src={img1} alt="first cow img in SectionOne"  id="img1" />
                </div>
                {/*--second img--*/}
                <div className='pic2'>
                  <img onLoad={Changing} src={img2} alt="second cow img in SectionOne" id="img2"/>
                </div>
                {/*--third img--*/}
                <div className='pic3'>
                  <img onLoad={Changing} src={img3} alt="third cow img in SectionOne" id="img3"/>
                </div>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*------SectionTwo------*/
/*========------------========*/
/*========------------========*/

function SectionTwo() { 
  return (
    <>
      {/*====Section2====*/}
      <section className='sectionTwo'>
        <Row>
          {/*--Video--*/} 
          <Col lg={7} md={12} xs={12} className='videoContainer'>
            <video className='video' autoPlay loop muted playsInline>
              <source src={video} />
            </video>
          </Col>
          {/*--Text--*/}
          <Col lg={5} md={12} xs={12} className='secTextTwo'>
            <div>
              <div className='before'>
                <h2 className='uno'>Krowy górskie, </h2>
                <h2 className='tres'>jakich nie znacie</h2>
              </div>
              <div className='after'>
                <h2>Krowy górskie, jakich nie znacie</h2>
              </div>
              <p>
                Krowy Highland, z charakterystycznymi długimi rogami i kudłatą sierścią, to jedna z najbardziej rozpoznawalnych i odpornych ras bydła.
                Wywodzą się z surowych, górzystych terenów Szkocji i są doskonale przystosowane do trudnych warunków pogodowych.
              </p>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*--------SectionThree--------*/
/*========------------========*/
/*========------------========*/


function Offerts({Changing}) {
  return (
    <>
      <section className='offerts' id='Products'>
        <div>
          <h2>Zasmakuj i odkryj więcej</h2>
        </div>
        <Row>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/sticks">
              <div className="OffertContainer">
              <img onLoad={Changing} src={sticks} alt="sticks" className='bigsize' id="sticks"/>
              <img onLoad={Changing} src={short1} alt="sticks" className='smallsize' id="short1"/>
              {/*--text on the picture--*/}
              <div className="textOnPic">
                <p>Paluszki</p>
              </div>
              </div>
            </Link>
          </Col>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/meat">
              <div className="OffertContainer">
                <img onLoad={Changing} src={meat} alt="meat" className='bigsize' id="meat"/>
                <img onLoad={Changing} src={short2} alt="meat" className='smallsize' id="short2"/>
                {/*--text on the picture--*/}
                <div className="textOnPic">
                  <p>Mięso</p>
                </div>
              </div>
            </Link>
          </Col>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/wine">
              <div className="OffertContainer">
                <img onLoad={Changing} src={wine} alt="wine" className='bigsize' id="wine"/>
                <img onLoad={Changing} src={short3} alt="wine" className='smallsize' id="short3"/>
                {/*--text on the picture--*/}
                <div className="textOnPic">
                  <p>Wino</p>
                </div>
              </div>
            </Link>
          </Col>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/tour">
              <div className="OffertContainer">
                <img onLoad={Changing} src={highlader} alt="tour" className='bigsize' id="highlader"/>
                <img onLoad={Changing} src={short4} alt="tour" className='smallsize' id="short4"/>
                {/*--text on the picture--*/}
                <div className="textOnPic">
                  <p>Wizyta</p>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*------SectionFourth------*/
/*========------------========*/
/*========------------========*/

function Gallery({Changing}) {
  return (
    <>
      <section className='Gallery'>
        <Row>
          {/*--column one--*/}
            <Col lg={4} md={6}>
              {/*-img-*/}
              <Row className='radius'>
                <Col>
                <Link to="/album">
                  <img onLoad={Changing} src={pic1} alt='krowa1' id="pic1"/>
                </Link>
                </Col>
              </Row>
              {/*-img-*/}
              <Row className='radius'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic2} alt='krowa2' id="pic2"/>
                  </Link>
                </Col>
              </Row>
              {/*-button-*/}
              <Row>
                <Col>
                  <Link to="/album">
                    <button>Zobacz więcej &#8594;</button>
                  </Link>
                </Col>
              </Row>
            </Col>
          {/*--column two--*/}
            <Col lg={4} md={6}>
              {/*-img-*/}
              <Row className='radius'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic3} alt='krowa3' id="pic3"/>
                  </Link>
                </Col>
              </Row>
            </Col>
          {/*--column three--*/}
            <Col lg={4} md={12} className='Col3'>
              {/*-img-*/}
              <Row className='radius secondoff'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic4} alt='krowa4' id="pic4"/>
                  </Link>
                </Col>
              </Row>
              <Row className='firstoff'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic5} alt='krowa5' id="pic5"/>
                  </Link>
                </Col>
              </Row>
            </Col>
        </Row>
      </section>
    </>
  );
}


/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer({Changing}) {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing} src={mu6} alt="Cow" id="mu6"/>
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing} src={mu4} alt="Cow" id="mu4"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing} src={mu3} alt="Cow" id="mu3"/>
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing} src={mu2} alt="Cow" id="mu2"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing} src={mu5} alt="Cow" id="mu5"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing} src={mu1} alt="Cow" id="mu1"/>
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*---------All apps-----------*/
/*========------------========*/
/*========------------========*/

function App() {
  const [loadedCount, setLoadedCount] = useState(null);
  
  const Changing = () => {
    setLoadedCount(prev => {
      const newCount = prev + 1;
      if (newCount === 22) {
        console.log("Photos loaded!");
        setTimeout(() => {
          console.log("Iaam loading better quality photos now");
  
          const safeSetSrc = (id, src) => {
            const el = document.getElementById(id);
            if (el) el.src = src;
            else console.warn(`Element ${id} nie znaleziony.`);
          };
  
          safeSetSrc("img1", img1h);
          safeSetSrc("img2", img2h);
          safeSetSrc("img3", img3h);
          safeSetSrc("wine", wineh);
          safeSetSrc("sticks", sticksh);
          safeSetSrc("highlader", highladerh);
          safeSetSrc("short1", short1h);
          safeSetSrc("short2", short2h);
          safeSetSrc("short3", short3h);
          safeSetSrc("short4", short4h);
          safeSetSrc("pic1", pic1h);
          safeSetSrc("pic2", pic2h);
          safeSetSrc("pic3", pic3h);
          safeSetSrc("pic4", pic4h);
          safeSetSrc("pic5", pic5h);
          safeSetSrc("mu1", mu1h);
          safeSetSrc("mu2", mu2h);
          safeSetSrc("mu3", mu3h);
          safeSetSrc("mu4", mu4h);
          safeSetSrc("mu5", mu5h);
          safeSetSrc("mu6", mu6h);
  
        }, 2000);
        console.log(loadedCount);
      }
      return newCount;
    });
  }

  return (
    <>
      <Welcome />
      <article className='AllSections'>
        <SectionOne Changing={Changing}/>
        <SectionTwo />
        <Offerts Changing={Changing}/>
        <Gallery Changing={Changing}/>
      </article>
      <Footer Changing={Changing}/>
    </>
  );
}

function Navigator() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/sticks" element={<Sticks />} />
        <Route path="/album" element={<Album /> } />
        <Route path="/meat" element={<Meat /> } />
        <Route path="/tour" element={<Tour /> } />
        <Route path="/wine" element={<Wine />} />
        <Route path="/story/:id" element={<Story />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Navigator;
